import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconEmail: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <path
            fill="currentColor"
            d="M43 8c.513 0 .935.386.993.883L44 9v29.008c0 .69-.682 1.172-1.332.943-.43-.152-.925-.297-1.48-.435l-.34-.081-.615-.136-.655-.13-.692-.125-.36-.06-.369-.059-.763-.112-.796-.106-.41-.05-1.057-.12-1.101-.108-.911-.079-.465-.037-.948-.067-.482-.03-.98-.057-1.001-.048-1.019-.04-1.035-.03-1.05-.023-1.064-.013L24 37l-1.075.005-1.064.013-1.05.023-1.291.04-1.265.053-.99.052-.97.06-.477.033-1.166.09-1.127.102-.87.089-.425.047-.828.1c-.27.034-.536.07-.796.106l-.385.055-.746.116-.36.06-.692.124c-.54.102-1.042.21-1.505.322l-.34.086-.531.146c-.255.074-.493.15-.714.228-.612.216-1.253-.198-1.326-.823L4 38.007V9c0-.513.386-.936.883-.993L5 8h38zM5.998 11.413L6 36.66l.297-.075c1.974-.491 4.6-.888 7.634-1.161l.573-.05 1.108-.086.566-.04 1.153-.07c.518-.028 1.044-.053 1.578-.075l.805-.03 1.226-.036 1.245-.024.629-.008L24 35l.634.002 1.257.012.622.01.617.014 1.22.037 1.198.048.59.028.584.03 1.147.07 1.118.082.548.044 1.07.097c2.62.253 4.916.599 6.72 1.02l.675.166-.001-25.245-15.878 15.878c-1.124 1.125-2.92 1.17-4.098.135l-.144-.135-15.881-15.88zm18.71 14.466L40.584 10H7.414l15.879 15.879c.36.36.928.388 1.32.083l.094-.083z"
          />
        </svg>
      </div>
    </div>
  )
}
export default IconEmail
